/**
 * Rounded Trigger
 * 
 * @Author: Focci
 * @Date: 2023-08-11 09:46:35
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-11 09:46:35
 */

import PropTypes from 'prop-types'
import { ButtonBase } from '@comp/material'
import clsx from 'clsx'

export default function RoundedTrigger({
  children,
  className = 'border',
  ...props
}) {
  return (
    <ButtonBase className="rounded-md" {...props} aria-label="Back top">
      <div 
        className={clsx([
          'rounded-md shadow-simple w-9 h-9',
          'flex items-center justify-center bg-white hover:bg-cf8',
          className
        ])}
      >
        {children}
      </div>
    </ButtonBase>
  )
}

RoundedTrigger.propTypes = {
  children: PropTypes.node,
}
